import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ContactService } from '../../../core/services/contact.service';
import { FormValidators } from '../../../core/validators/form-validators';

@Component({
  selector: 'app-contact-create',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink, MatIconModule],
  templateUrl: './contact-create.component.html',
  styleUrls: [`contact-create.component.css`]
})
export class ContactCreateComponent {
  private fb = inject(FormBuilder);
  private contactService = inject(ContactService);
  private router = inject(Router);

  isLoading = signal(false);
  errorMessage = signal<string | null>(null);

  contactForm = this.fb.group({
    nom: ['', [Validators.required]],
    prenom: ['', [Validators.required]],
    telephone: ['', [FormValidators.telephoneFr()]],
    email: ['', [Validators.email]]
  });

  onSubmit() {
    // Marque tous les champs comme touchés pour afficher les erreurs immédiatement
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) {
      return;
    }

    if (this.contactForm.valid) {
      this.isLoading.set(true);
      this.errorMessage.set(null);

      this.contactService.createContact(this.contactForm.value as any).subscribe({
        next: () => {
          this.router.navigate(['/contacts']);
        },
        error: (err) => {
          this.errorMessage.set(err.error?.message || err.error || 'Une erreur est survenue lors de la création du contact.');
          this.isLoading.set(false);
        }
      });
    }
  }
}
